var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495.72 35.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05DC\\u05D5\\u05D7_\\u05D0\\u05D9\\u05E8\\u05D5\\u05E2\\u05D9\\u05DD",
    "data-name": "\\u05DC\\u05D5\\u05D7 \\u05D0\\u05D9\\u05E8\\u05D5\\u05E2\\u05D9\\u05DD"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,1.36h10.7v18.01H0V1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.83,17.74C15.83,7.81,23.2.27,33.29.27s17.41,7.53,17.41,17.47-7.37,17.47-17.41,17.47-17.47-7.53-17.47-17.47ZM33.29,25.38c3.88,0,6.71-3.22,6.71-7.64s-2.84-7.64-6.71-7.64-6.77,3.22-6.77,7.64,2.84,7.64,6.77,7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.79,24.67V1.36h10.64l.05,32.75h-19.1v-9.44h8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.17,10.81h-15.12V1.36h25.82v32.75h-10.7V10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,25.38c3.98,0,6.93-3.17,6.93-7.64,0-6.6-4.2-8.62-8.73-6.88l-2.62-8.79c11.46-4.37,22.05,1.36,22.05,15.66,0,10.15-7.48,17.47-17.63,17.47s-17.79-7.31-17.79-17.47V1.36h10.7v16.37c0,4.48,3,7.64,7.1,7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.01,10.81h-20.69V1.36h31.38v32.75h-10.7V10.81ZM150.7,16.81h10.7v17.3h-10.7v-17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.46,10.81h-8.46v23.31h-16.26v-9.44h5.57v-13.86h-3.93V1.36h33.79v32.75h-10.7V10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.6,1.36h10.7v18.01h-10.7V1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.12,34.11h-28.87v-9.44h13.48v-13.86h-13.48V1.36h24.18v23.31h4.69v9.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.29,10.81h-20.69V1.36h31.38v32.75h-10.7V10.81ZM293.98,16.81h10.7v17.3h-10.7v-17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.33,1.36h10.7v18.01h-10.7V1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.92,1.36v32.75h-32.37v-9.44h5.68V1.36h10.7v23.31h5.29V1.36h10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M397.63,1.36h10.7v32.75h-10.7V1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.02,10.81h-15.12V1.36h25.82v32.75h-10.7V10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M446.16,1.36h10.7v18.01h-10.7V1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M473.99,23.03v11.08h-10.7V0h.16l14.03,12.23,9.61-12.23,8.57,6.39-10.32,12.66,10.37,9.06-7.2,7.86-14.52-12.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/אירועי הבית הטרנסיmdpi.2b2a5e7bae740cf0a36a206c5cda12f7.svg";
export { ForwardRef as ReactComponent };